// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"e6a0d768","82":"13706004","849":"92a3464f","983":"2d85d67a"}[chunkId] + ".chunk.css";
};